import type { IClientEvent } from '@/entities/client-event.entity';
import { milestoneLabel } from '@/entities/dropper-funnel';
import { cn } from '@/lib/utils';
import { AlertTriangleIcon, CheckCircle2Icon, CircleIcon } from 'lucide-react';
import TimeAgo from 'react-timeago';
import russianStrings from 'react-timeago/lib/language-strings/ru';
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter';

const formatter = buildFormatter(russianStrings);

interface ClientEventCardProps {
	event: IClientEvent;
}

export default function ClientEventCard({ event }: ClientEventCardProps) {
	const isError = event.kind === 'error' || event.kind === 'crash' || event.kind === 'anr' || event.kind === 'native';
	const Icon = isError ? AlertTriangleIcon : event.kind === 'stage' ? CheckCircle2Icon : CircleIcon;

	return (
		<div className='rounded-md border border-border bg-card px-3 py-2 grid gap-1'>
			<div className='flex items-start gap-2 min-w-0'>
				<Icon size={16} className={cn('shrink-0 mt-0.5', isError ? 'text-destructive' : 'text-chart-2')} />
				<div className='min-w-0 flex-1'>
					<div className='flex items-center gap-2 flex-wrap'>
						<span className='text-sm font-medium'>{milestoneLabel(event.name)}</span>
						<span className='text-[10px] uppercase tracking-wide text-muted-foreground'>{event.source}</span>
					</div>
					<p className='text-xs text-muted-foreground break-words'>{event.message}</p>
				</div>
				<span className='text-[11px] text-muted-foreground shrink-0'>
					<TimeAgo date={event.occurredAt} formatter={formatter} />
				</span>
			</div>
			{event.stackTrace ? (
				<pre className='text-[10px] text-muted-foreground whitespace-pre-wrap break-all max-h-24 overflow-auto'>{event.stackTrace}</pre>
			) : null}
		</div>
	);
}
